export default __webpack_public_path__ + "static/media/trainTtsIt_It60.13c17fd8.mp3";